import { groupBy, orderBy, uniq } from 'lodash';
import { LOAN_COMPARE_GROUPS, LOAN_COMPARE_KEYS } from '../Constants';

const mapKeys = (loanDataItems) => {
  const obj = {};
  const keys: string[] = [];

  loanDataItems.forEach((item) => {
    const shortLookup = `${item.category} ${item.type}`;
    const longLookup = `${item.category} ${item.type} ${item.sub_type}`;
    const mapping = LOAN_COMPARE_KEYS[shortLookup] || LOAN_COMPARE_KEYS[longLookup];

    if (mapping) {
      const key = `${mapping.group}|${mapping.value}`;
      obj[key] = item;
      keys.push(key);
    }
  });

  return { keys: uniq(keys), data: obj };
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const formatLoanCompareData = (loans) => {
  const obj = {};
  let keys: any = [];
  loans.forEach((loan) => {
    if (loan.data) {
      const config = mapKeys(loan.data);
      // eslint-disable-next-line no-param-reassign
      loan.data = config.data;
      keys = keys.concat(config.keys);
    } else {
      // eslint-disable-next-line no-param-reassign
      loan.data = {};
    }

    obj[loan.id] = loan;
  });

  keys = uniq(keys);
  keys = groupBy(keys, (key) => key.split('|')[0]);
  return { loans: obj, keys, categories: orderBy(Object.keys(keys), (key) => LOAN_COMPARE_GROUPS.indexOf(key)) };
};
